import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "max-w-4xl mx-auto p-6" }
const _hoisted_2 = { class: "bg-white shadow-md rounded-lg p-8" }
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = { class: "flex flex-col items-center" }
const _hoisted_6 = {
  key: 0,
  class: "mb-6 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded"
}
const _hoisted_7 = {
  key: 1,
  class: "space-y-6"
}
const _hoisted_8 = {
  key: 2,
  class: "space-y-6"
}
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = {
  key: 0,
  class: "mt-2 inline-flex items-center gap-2 px-3 py-1 bg-brand-100 text-brand-800 rounded-full text-sm"
}
const _hoisted_11 = {
  key: 1,
  class: "absolute z-10 w-full bg-white border border-gray-300 rounded-md mt-1 max-h-48 overflow-y-auto shadow-lg"
}
const _hoisted_12 = ["onMousedown"]
const _hoisted_13 = { class: "text-gray-400 ml-1" }
const _hoisted_14 = { class: "flex gap-4" }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 3,
  class: "space-y-6"
}
const _hoisted_17 = { class: "mb-4" }
const _hoisted_18 = { class: "border border-gray-300 rounded-md p-4 max-h-96 overflow-y-auto" }
const _hoisted_19 = {
  key: 0,
  class: "text-center text-gray-500 py-8"
}
const _hoisted_20 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_21 = { class: "flex items-center cursor-pointer flex-1" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "ml-3 text-gray-700" }
const _hoisted_24 = {
  key: 0,
  class: "ml-4 text-sm text-gray-500"
}
const _hoisted_25 = { class: "mt-2 text-sm text-gray-500" }
const _hoisted_26 = {
  key: 4,
  class: "text-center py-8 space-y-4"
}
const _hoisted_27 = { class: "flex justify-between mt-8 pt-6 border-t border-gray-200" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "flex space-x-3" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[25] || (_cache[25] = _createElementVNode("h1", { class: "text-3xl font-bold mb-8 text-gray-800" }, "Create New Job Search", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.steps, (step) => {
            return (_openBlock(), _createElementBlock("div", {
              key: step.number,
              class: _normalizeClass(["flex items-center", { 'flex-1': step.number < $setup.steps.length }])
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-colors", $setup.currentStep >= step.number ? 'bg-brand-600 text-white' : 'bg-gray-300 text-gray-600'])
                }, _toDisplayString(step.number), 3),
                _createElementVNode("span", {
                  class: _normalizeClass(["mt-2 text-sm font-medium", $setup.currentStep >= step.number ? 'text-brand-600' : 'text-gray-500'])
                }, _toDisplayString(step.label), 3)
              ]),
              (step.number < $setup.steps.length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["flex-1 h-1 mx-4 transition-colors", $setup.currentStep > step.number ? 'bg-brand-600' : 'bg-gray-300'])
                  }, null, 2))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ])
      ]),
      ($setup.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.errorMessage), 1))
        : _createCommentVNode("", true),
      ($setup.currentStep === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _cache[15] || (_cache[15] = _createElementVNode("label", {
                for: "searchName",
                class: "block text-sm font-medium text-gray-700 mb-2"
              }, " Search Name ", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "searchName",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchData.title) = $event)),
                type: "text",
                placeholder: "e.g., Senior Frontend Developer - Remote",
                class: "w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-600",
                onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => ($setup.nextStep && $setup.nextStep(...args)), ["enter"]))
              }, null, 544), [
                [_vModelText, $setup.searchData.title]
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("p", { class: "mt-2 text-sm text-gray-500" }, " Give your search a descriptive name to easily identify it later ", -1))
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.currentStep === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[17] || (_cache[17] = _createElementVNode("label", {
                for: "location",
                class: "block text-sm font-medium text-gray-700 mb-2"
              }, " Location ", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "location",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.locationQuery) = $event)),
                type: "text",
                placeholder: "Start typing a city or region...",
                autocomplete: "off",
                class: "w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-600",
                onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.onLocationInput && $setup.onLocationInput(...args))),
                onFocus: _cache[4] || (_cache[4] = ($event: any) => ($setup.showSuggestions = $setup.locationSuggestions.length > 0))
              }, null, 544), [
                [_vModelText, $setup.locationQuery]
              ]),
              ($setup.selectedLocation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createTextVNode(_toDisplayString($setup.selectedLocation.raw_string) + " ", 1),
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.clearLocation && $setup.clearLocation(...args))),
                      class: "text-blue-500 hover:text-brand-700 font-bold"
                    }, "×")
                  ]))
                : _createCommentVNode("", true),
              ($setup.showSuggestions && $setup.locationSuggestions.length > 0)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.locationSuggestions, (loc) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: loc.id,
                        class: "px-4 py-2 hover:bg-brand-50 cursor-pointer text-sm",
                        onMousedown: _withModifiers(($event: any) => ($setup.selectLocation(loc)), ["prevent"])
                      }, [
                        _createTextVNode(_toDisplayString(loc.raw_string) + " ", 1),
                        _createElementVNode("span", _hoisted_13, _toDisplayString([loc.state_province, loc.country].filter(Boolean).join(', ')), 1)
                      ], 40, _hoisted_12))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Work Type", -1)),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.workTypes, (wt) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: wt.value,
                    class: _normalizeClass(["flex items-center gap-2 px-4 py-2 border rounded-md cursor-pointer transition-colors", $setup.searchData.work_type === wt.value
                ? 'border-brand-600 bg-brand-50 text-brand-700'
                : 'border-gray-300 hover:bg-gray-50 text-gray-700'])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      value: wt.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.searchData.work_type) = $event)),
                      class: "hidden"
                    }, null, 8, _hoisted_15), [
                      [_vModelRadio, $setup.searchData.work_type]
                    ]),
                    _createTextVNode(" " + _toDisplayString(wt.label), 1)
                  ], 2))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.currentStep === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", null, [
              _cache[19] || (_cache[19] = _createElementVNode("label", {
                for: "overallExperience",
                class: "block text-sm font-medium text-gray-700 mb-2"
              }, [
                _createTextVNode(" Total Years of Professional Experience "),
                _createElementVNode("span", { class: "text-red-500" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "overallExperience",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.searchData.overall_experience) = $event)),
                type: "number",
                min: "0",
                max: "50",
                placeholder: "e.g., 5",
                class: "w-32 px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-600"
              }, null, 512), [
                [
                  _vModelText,
                  $setup.searchData.overall_experience,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[20] || (_cache[20] = _createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, " Your total years of professional experience (used to filter out jobs requiring more experience than you have). ", -1))
            ]),
            _createElementVNode("div", null, [
              _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-4" }, " Select Skills for This Search ", -1)),
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.skillFilterTerm) = $event)),
                  type: "text",
                  placeholder: "Filter skills...",
                  class: "w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-600"
                }, null, 512), [
                  [_vModelText, $setup.skillFilterTerm]
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                ($setup.filteredMySkills.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _cache[22] || (_cache[22] = _createElementVNode("p", null, "No skills found. Please add skills in the My Skills page first.", -1)),
                      _createVNode(_component_router_link, {
                        to: "/my-skills",
                        class: "text-brand-600 hover:text-brand-700 font-medium mt-2 inline-block"
                      }, {
                        default: _withCtx(() => _cache[21] || (_cache[21] = [
                          _createTextVNode(" Go to My Skills ")
                        ])),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredMySkills, (skill) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: skill.skill_id,
                          class: "flex items-center justify-between p-3 hover:bg-gray-50 rounded-md transition-colors"
                        }, [
                          _createElementVNode("label", _hoisted_21, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: skill.skill_id,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.selectedSkillIds) = $event)),
                              class: "w-4 h-4 text-brand-600 border-gray-300 rounded focus:ring-brand-600"
                            }, null, 8, _hoisted_22), [
                              [_vModelCheckbox, $setup.selectedSkillIds]
                            ]),
                            _createElementVNode("span", _hoisted_23, _toDisplayString(skill.skill_name), 1)
                          ]),
                          ($setup.selectedSkillIds.includes(skill.skill_id))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(skill.years_experience ?? 0) + " yr" + _toDisplayString((skill.years_experience ?? 0) !== 1 ? 's' : ''), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
              ]),
              _createElementVNode("p", _hoisted_25, " Selected: " + _toDisplayString($setup.selectedSkillIds.length) + " skill(s) ", 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.currentStep === 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _cache[24] || (_cache[24] = [
            _createStaticVNode("<div class=\"w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto\" data-v-7cf63728><svg class=\"w-8 h-8 text-green-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-7cf63728><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M5 13l4 4L19 7\" data-v-7cf63728></path></svg></div><h2 class=\"text-2xl font-semibold text-gray-800\" data-v-7cf63728>Job search created!</h2><p class=\"text-gray-600\" data-v-7cf63728>Your search is set up and will run within the next 24 hours.</p><p class=\"text-sm text-gray-500\" data-v-7cf63728>We&#39;ll notify you when matching jobs are found.</p>", 4)
          ])))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_27, [
        ($setup.currentStep > 1 && $setup.currentStep < 4)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.previousStep && $setup.previousStep(...args))),
              class: "px-6 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
            }, " Previous "))
          : (_openBlock(), _createElementBlock("div", _hoisted_28)),
        _createElementVNode("div", _hoisted_29, [
          ($setup.currentStep < 4)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.cancel && $setup.cancel(...args))),
                class: "px-6 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
              }, " Cancel "))
            : _createCommentVNode("", true),
          ($setup.currentStep < 3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => ($setup.nextStep && $setup.nextStep(...args))),
                disabled: !$setup.canProceed,
                class: "px-6 py-2 bg-brand-600 text-white rounded-md hover:bg-brand-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
              }, " Next ", 8, _hoisted_30))
            : ($setup.currentStep === 3)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => ($setup.saveSearch && $setup.saveSearch(...args))),
                  disabled: !$setup.canSave || $setup.saving,
                  class: "px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
                }, _toDisplayString($setup.saving ? 'Saving...' : 'Save Search'), 9, _hoisted_31))
              : (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => ($setup.cancel && $setup.cancel(...args))),
                  class: "px-6 py-2 bg-brand-600 text-white rounded-md hover:bg-brand-700"
                }, " View My Searches "))
        ])
      ])
    ])
  ]))
}